// import amplitude from 'amplitude-js';
import { getConfig } from '@oneclick/react-lemonade-editor';

function getEnv(domain) {
  if (domain.indexOf('-dev') !== -1 || domain.indexOf('localhost') !== -1) return 'development';
  if (domain.indexOf('-qa') !== -1) return 'qa';
  return 'production';
}

export function initMetrics() {
  const domain = window.location.origin;
  const env = domain && getEnv(domain);
  // console.log(domain, env);
  getConfig().initLemoAmplitude(domain, env);
  // amplitude.getInstance().init(AMPLITUDE_API_KEY);
}

export function setUser(userId) {
  // amplitude.getInstance().setUserId(userId);
}

export function trackEvent(eventName) {
  // amplitude.getInstance().logEvent(eventName);
}
